import ScrollMagic from 'scrollmagic';
// import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators'

let controller;

function setController() {
    controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            reverse: false,
        },
    });
}

const inViewport = (elem, height) => {
    const bounding = elem.getBoundingClientRect();
    const windowHeight = height !== undefined ? height : window.innerHeight;

    return bounding.top <= windowHeight;
};

function initJsFade(jsFadeItems) {
    const { innerHeight } = window;
    // const triggerHook = innerHeight / window.innerHeight;
    const triggerHook = 0.95;

    let initCount = 0;
    let timeout = 400;

    setTimeout(() => {
        Array.from(jsFadeItems).forEach((trigger) => {
            const jsFadeItemsScene = new ScrollMagic.Scene({
                triggerElement: trigger,
                duration: trigger.scrollHeight,
                triggerHook: triggerHook,
            })
                // .addIndicators()
                .addTo(controller);

            if (
                trigger.classList.contains('js-fade-delay') &&
                inViewport(trigger, innerHeight) === false
            ) {
                trigger.style.transitionDelay = `${initCount * 0.2}s`;
                initCount++;
            }

            jsFadeItemsScene.on('enter', (event) => {
                if (event.type === 'enter') {
                    trigger.classList.add('animated');
                }
            });
        });
    }, timeout);
}

document.addEventListener('DOMContentLoaded', () => {
    const jsFadeItems = document.querySelectorAll('.js-fade');
    setController();

    if (jsFadeItems.length > 0) {
        initJsFade(jsFadeItems);
    }
});